import React from 'react'
import DataSource from '../DataSource'
import Heading from '../components/Heading'
import ModuleWithLoader from '../components/ModuleWithLoader'
import CapMySpendForm from '../forms/CapMySpendForm'
import PaymentInformation from './PaymentInformation'
import ThingsToKnow from './ThingsToKnow'
import globals from '../globals'

class CapMySpend extends React.Component {
    constructor (props) {
        super(props)

        this.state = {
            isLoaded: false,
            hasError: false,
            fields: {}
        }
    }

    componentDidMount () {
        DataSource.getData(`/api/getCapSpendData/${this.props.serviceId}`, result => {
            this.setState({
                fields: result.fields,
                isLoaded: true
            })
        }, () => {
            this.setState({ hasError: true, isLoaded: true })
        })
    }

    handleSuccess (response, state) {
	    globals.pushEvent('SpendCap', { amount: state.amount })
    }

    render () {
        return (
            <div>
                <div className='cap-my-spend module' style={{ overflow: 'visible' }}>
                    <Heading title={this.props.title} />
                    <ModuleWithLoader isLoaded={this.state.isLoaded} hasError={this.state.hasError} className='p-4'>
                        <div className='row'>
                            <div className='col-12 col-md-8 offset-md-2 text-center'>
                                <p>Our spend control function gives you the peace of mind knowing that you can limit any additional usage each month and avoid any bill surprises. Just set the monthly cap below and we will pause services that attract excess usage once your cap is reached.</p>
                            </div>
                        </div>
                        <div className='row'>
                            <div className='col-12 col-md-8 offset-md-2'>
                                <CapMySpendForm
                                    serviceId={this.props.serviceId}
                                    cappedSpend={this.props.cappedSpend}
                                    fields={this.state.fields}
                                    handleSuccess={this.handleSuccess.bind(this)}
                                />
                            </div>
                        </div>
                    </ModuleWithLoader>
                </div>
                <PaymentInformation />
                <ThingsToKnow type='capMySpend' />
            </div>
        )
    }
}

export default CapMySpend



// WEBPACK FOOTER //
// ./resources/js/modules/CapMySpend.js